import { crsfInterceptorFn, generalAuthInterceptorFn } from './auth-interceptor.function';

export const AUTH_HTTP_INTERCEPTORS = [
  generalAuthInterceptorFn,
  crsfInterceptorFn,
];
